const login = {
  password: 'Mot de passe',
  login: 'Connexion',
  sign_in: 'Se connecter',
  click_msg: 'En cliquant sur Se connecter, vous acceptez nos',
  terms: 'Termes et conditions',
  and: 'et',
  privacy: 'Politique de confidentialité',
  account_msg: "Vous n'avez pas de compte ?",
  register_here: 'Inscrivez-vous ici',
  sign_in_error: 'Erreur. Veuillez réessayer de vous connecter...',
  cloud_based_title: "Système de contrôle d'accès cloud",
};

export default login;
